import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import styles from "./detail-tabela.module.scss";
import type { DetailTabelaProps } from "./types-detail-tabela";

/** Tabela interna de leitura (Figma 8148:28941): sem ordenação, paginação nem filtros; rola na horizontal no mobile. */
export function DetailTabelaView({ title, testId, minWidth, columns, rows }: DetailTabelaProps) {
  return (
    <div className={styles.frame}>
      <DataTable
        value={[...rows]}
        size="large"
        dataKey="key"
        tableStyle={{ minWidth }}
        aria-label={title}
        data-testid={testId}
      >
        {columns.map(({ field, header }) => (
          <Column key={field} field={field} header={header} bodyClassName={styles.cell} />
        ))}
      </DataTable>
    </div>
  );
}
